var map = {
	"./Favorites": [
		1106,
		9,
		98
	],
	"./Favorites.tsx": [
		1106,
		9,
		98
	],
	"./FavoritesDeferred": [
		349,
		9
	],
	"./FavoritesDeferred.tsx": [
		349,
		9
	],
	"./FavoritesPage": [
		348,
		9
	],
	"./FavoritesPage.dictionary": [
		332,
		3
	],
	"./FavoritesPage.dictionary.json": [
		332,
		3
	],
	"./FavoritesPage.explanation": [
		1107,
		9,
		99
	],
	"./FavoritesPage.explanation.ts": [
		1107,
		9,
		99
	],
	"./FavoritesPage.tsx": [
		348,
		9
	],
	"./actions": [
		102,
		9
	],
	"./actions/": [
		102,
		9
	],
	"./actions/index": [
		102,
		9
	],
	"./actions/index.ts": [
		102,
		9
	],
	"./components/Loader": [
		1002,
		9,
		56
	],
	"./components/Loader/": [
		1002,
		9,
		56
	],
	"./components/Loader/Loader": [
		953,
		9,
		188
	],
	"./components/Loader/Loader.dictionary": [
		919,
		3,
		189
	],
	"./components/Loader/Loader.dictionary.json": [
		919,
		3,
		189
	],
	"./components/Loader/Loader.explanation": [
		1108,
		9,
		190
	],
	"./components/Loader/Loader.explanation.ts": [
		1108,
		9,
		190
	],
	"./components/Loader/Loader.module.scss": [
		1014,
		9,
		289
	],
	"./components/Loader/Loader.tsx": [
		953,
		9,
		188
	],
	"./components/Loader/index": [
		1002,
		9,
		56
	],
	"./components/Loader/index.ts": [
		1002,
		9,
		56
	],
	"./components/NoData": [
		1003,
		9,
		58
	],
	"./components/NoData/": [
		1003,
		9,
		58
	],
	"./components/NoData/NoData": [
		954,
		9,
		192
	],
	"./components/NoData/NoData.dictionary": [
		922,
		3,
		193
	],
	"./components/NoData/NoData.dictionary.json": [
		922,
		3,
		193
	],
	"./components/NoData/NoData.explanation": [
		1109,
		9,
		194
	],
	"./components/NoData/NoData.explanation.ts": [
		1109,
		9,
		194
	],
	"./components/NoData/NoData.module.scss": [
		1015,
		9,
		291
	],
	"./components/NoData/NoData.tsx": [
		954,
		9,
		192
	],
	"./components/NoData/index": [
		1003,
		9,
		58
	],
	"./components/NoData/index.ts": [
		1003,
		9,
		58
	],
	"./components/NoDataSkeleton": [
		887,
		9,
		59
	],
	"./components/NoDataSkeleton/": [
		887,
		9,
		59
	],
	"./components/NoDataSkeleton/NoDataSkeleton": [
		869,
		9,
		195
	],
	"./components/NoDataSkeleton/NoDataSkeleton.module.scss": [
		920,
		9,
		292
	],
	"./components/NoDataSkeleton/NoDataSkeleton.tsx": [
		869,
		9,
		195
	],
	"./components/NoDataSkeleton/constants": [
		888,
		9,
		196
	],
	"./components/NoDataSkeleton/constants.ts": [
		888,
		9,
		196
	],
	"./components/NoDataSkeleton/index": [
		887,
		9,
		59
	],
	"./components/NoDataSkeleton/index.ts": [
		887,
		9,
		59
	],
	"./components/PopularMatches": [
		889,
		9,
		61
	],
	"./components/PopularMatches/": [
		889,
		9,
		61
	],
	"./components/PopularMatches/PopularMatches": [
		870,
		9,
		201
	],
	"./components/PopularMatches/PopularMatches.dictionary": [
		872,
		3,
		202
	],
	"./components/PopularMatches/PopularMatches.dictionary.json": [
		872,
		3,
		202
	],
	"./components/PopularMatches/PopularMatches.explanation": [
		1110,
		9,
		203
	],
	"./components/PopularMatches/PopularMatches.explanation.ts": [
		1110,
		9,
		203
	],
	"./components/PopularMatches/PopularMatches.module.scss": [
		921,
		9,
		294
	],
	"./components/PopularMatches/PopularMatches.tsx": [
		870,
		9,
		201
	],
	"./components/PopularMatches/index": [
		889,
		9,
		61
	],
	"./components/PopularMatches/index.ts": [
		889,
		9,
		61
	],
	"./components/SportGrid": [
		856,
		9,
		68
	],
	"./components/SportGrid/": [
		856,
		9,
		68
	],
	"./components/SportGrid/SportGrid": [
		841,
		9,
		215
	],
	"./components/SportGrid/SportGrid.module.scss": [
		871,
		9,
		299
	],
	"./components/SportGrid/SportGrid.tsx": [
		841,
		9,
		215
	],
	"./components/SportGrid/index": [
		856,
		9,
		68
	],
	"./components/SportGrid/index.ts": [
		856,
		9,
		68
	],
	"./components/TournamentTable": [
		842,
		9,
		79
	],
	"./components/TournamentTable/": [
		842,
		9,
		79
	],
	"./components/TournamentTable/TournamentTable": [
		833,
		9,
		228
	],
	"./components/TournamentTable/TournamentTable.ts": [
		833,
		9,
		228
	],
	"./components/TournamentTable/index": [
		842,
		9,
		79
	],
	"./components/TournamentTable/index.ts": [
		842,
		9,
		79
	],
	"./reducer": [
		294,
		9
	],
	"./reducer/": [
		294,
		9
	],
	"./reducer/entities": [
		366,
		9
	],
	"./reducer/entities.ts": [
		366,
		9
	],
	"./reducer/index": [
		294,
		9
	],
	"./reducer/index.js": [
		294,
		9
	],
	"./reducer/presentation": [
		367,
		9
	],
	"./reducer/presentation.ts": [
		367,
		9
	],
	"./selectors/gridEntities": [
		125,
		9
	],
	"./selectors/gridEntities.ts": [
		125,
		9
	],
	"./selectors/gridPresentation": [
		1057,
		9,
		239
	],
	"./selectors/gridPresentation.ts": [
		1057,
		9,
		239
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1235;
module.exports = webpackAsyncContext;